import { FormattedMessage, useIntl } from 'react-intl';
import { Alert, AlertTitle, Button, Stack, Tooltip } from '@rossum/ui/material';

type ExternalChangesNotificationProps = {
  onDismiss: () => void;
  onMerge: () => void;
  onRefresh: () => void;
  canMerge: boolean;
};

export const ExternalChangesNotification = ({
  onDismiss,
  onMerge,
  onRefresh,
  canMerge,
}: ExternalChangesNotificationProps) => {
  const intl = useIntl();

  return (
    <Alert
      severity="warning"
      sx={{ maxWidth: 600 }}
      data-cy="external-changes-notification"
    >
      <AlertTitle>
        <FormattedMessage id="containers.queueSchema.externalChanges.title" />
      </AlertTitle>
      <FormattedMessage id="containers.queueSchema.externalChanges.message" />
      <Stack
        direction="row"
        spacing={1}
        sx={{ mt: 2, justifyContent: 'flex-end' }}
      >
        <Tooltip
          title={intl.formatMessage({
            id: 'containers.queueSchema.externalChanges.dismissTooltip',
          })}
        >
          <Button
            color="inherit"
            onClick={onDismiss}
            data-cy="accept-yours-btn"
          >
            <FormattedMessage id="containers.queueSchema.externalChanges.dismiss" />
          </Button>
        </Tooltip>
        {canMerge ? (
          <Button
            variant="contained"
            color="warning"
            onClick={onMerge}
            data-cy="merge-btn"
          >
            <FormattedMessage id="containers.queueSchema.externalChanges.merge" />
          </Button>
        ) : (
          <Tooltip
            title={intl.formatMessage({
              id: 'containers.queueSchema.externalChanges.refreshTooltip',
            })}
          >
            <Button
              color="inherit"
              onClick={onRefresh}
              data-cy="accept-remote-btn"
            >
              <FormattedMessage id="containers.queueSchema.externalChanges.refresh" />
            </Button>
          </Tooltip>
        )}
      </Stack>
    </Alert>
  );
};
